(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-cart-drawer"]) return;
  try {
    
(function() {
  'use strict';

  const RUNTIME = (() => {
    try {
      const el = document.getElementById('FcDrawerRuntimeConfig');
      return el ? JSON.parse(el.textContent) : {};
    } catch (e) {
      return {};
    }
  })();

  // ─── ELEMENTS ─────────────────────────────────────────────────────────────
  const $ = id => document.getElementById(id);
  const EL = {
    items:       $('FcItems'),
    footer:      $('FcFooterCount'),
    total:       $('FcTotal'),
    upsell:      $('FcUpsell'),
    upsellList:  $('FcUpsellList'),
    banner:      $('FcFreebieBanner'),
    body:        $('FcBody'),
    delivery:    $('FcEstimatedDelivery'),
    deliveryText: $('FcEstimatedDeliveryText'),
    customTumbler: $('FcCustomTumbler'),
  };

  const CT = window.__FRIDO_CUSTOM_TUMBLER__ || { enabled: false };

  (function hydrateSuprBrewOfferGlobals() {
    try {
      if (!window.__SUPR_CUSTOM_TUMBLER_RESTRICT_TO_PRODUCT_IDS__?.length) {
        const restricted = window.sessionStorage.getItem('supr-tumbler-restrict-ids');
        if (restricted) {
          window.__SUPR_CUSTOM_TUMBLER_RESTRICT_TO_PRODUCT_IDS__ = JSON.parse(restricted);
        }
      }
      if (!window.__SUPR_VARIANT_FREEBIE_RULES__?.length) {
        const rules = window.sessionStorage.getItem('supr-variant-freebie-rules');
        if (rules) {
          window.__SUPR_VARIANT_FREEBIE_RULES__ = JSON.parse(rules);
        }
      }
    } catch (e) {}
  })();

  function portalCartDrawerToBody() {
    ['FcBackdrop', 'FcDrawer'].forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      if (el.parentElement !== document.body) {
        document.body.appendChild(el);
      }
      el.style.setProperty('position', 'fixed', 'important');
    });
    var drawer = document.getElementById('FcDrawer');
    if (drawer) {
      drawer.style.setProperty('top', '0', 'important');
      drawer.style.setProperty('right', '0', 'important');
      drawer.style.setProperty('left', 'auto', 'important');
      drawer.style.setProperty('height', '100dvh', 'important');
      drawer.style.setProperty('max-height', '100dvh', 'important');
    }
  }

  portalCartDrawerToBody();
  document.addEventListener('DOMContentLoaded', portalCartDrawerToBody);
  document.addEventListener('shopify:section:load', portalCartDrawerToBody);

  function updateEstimatedDeliveryDate() {
    if (!EL.delivery || !EL.deliveryText) return;
    const days = parseInt(EL.delivery.dataset.days || '5', 10);
    const d = new Date();
    d.setDate(d.getDate() + days);
    const formatted = d.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
    EL.deliveryText.textContent = 'Estimated delivery: ' + formatted;
  }

  // ─── STATE ────────────────────────────────────────────────────────────────
  // Local cart state — source of truth for UI; kept in sync with Shopify
  let _cart = null;
  // Pending qty changes: key → targetQty (batched)
  const _pendingQtyChanges = {};
  let   _qtyFlushTimer = null;
  const QTY_DEBOUNCE = 380; // ms
  // Store previous URL before opening drawer (to restore on close)
  let _previousUrl = null;
  // Track if cart is being updated (disable checkout during updates)
  let _cartUpdating = false;
  let _giftNoteTimer = null;
  let _giftNotePromise = Promise.resolve();
  let _lastSavedGiftNote = RUNTIME.lastSavedGiftNote || '';
  let _fcCheckoutResume = false;
  const SUPR_3KG_GIFT_PROP = 'Included with';
  const SUPR_3KG_GIFT_VAL = '3 kg SUPR Brew';

  const CFG = window.__FRIDO_FREEBIE_CONFIG__ || { minCartValue: 0, mappings: [], fallbackFreebies: [], freebieImageOnly: false };
  const CT_PROP = (CT && CT.propertyKey) || 'Name on tumbler';
  const CT_FLAG = (CT && CT.flagKey) || '_custom_tumbler';

  // ─── MONEY ────────────────────────────────────────────────────────────────
  function fmt(cents) {
    return '₹' + (cents / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 });
  }

  function getLineProperty(item, name) {
    const p = item && item.properties;
    if (!p) return '';
    if (Array.isArray(p)) {
      const hit = p.find(x => x && String(x.name) === String(name));
      return hit ? String(hit.value || '') : '';
    }
    if (Object.prototype.hasOwnProperty.call(p, name)) return String(p[name] || '');
    return '';
  }

  function isCustomTumblerLine(item) {
    if (!item || !CT || !CT.variantId) return false;
    if (Number(item.variant_id) === Number(CT.variantId)) return true;
    return String(getLineProperty(item, CT_FLAG)) === 'true';
  }

  function getCustomTumblerBundleIdSet() {
    let restricted = window.__SUPR_CUSTOM_TUMBLER_RESTRICT_TO_PRODUCT_IDS__;
    if (!Array.isArray(restricted) || restricted.length === 0) {
      try {
        const stored = window.sessionStorage.getItem('supr-tumbler-restrict-ids');
        if (stored) restricted = JSON.parse(stored);
      } catch (e) {}
    }
    if (Array.isArray(restricted) && restricted.length > 0) {
      return new Set(restricted.map(Number).filter(Boolean));
    }
    const ids = new Set((CT.bundleProductIds || []).map(Number).filter(Boolean));
    const extras = window.__SUPR_CUSTOM_TUMBLER_EXTRA_BUNDLE_IDS__;
    if (Array.isArray(extras)) {
      extras.forEach(function (id) {
        const n = Number(id);
        if (n) ids.add(n);
      });
    }
    return ids;
  }

  function cartHasCustomTumblerBundle(items) {
    if (!CT || !CT.enabled) return false;
    const ids = getCustomTumblerBundleIdSet();
    /* No bundle product selected in theme settings → never show the offer */
    if (ids.size === 0) return false;
    return (items || []).some(function(i) {
      if (!i) return false;
      if (isFreebieItem(i)) return false;
      if (isCustomTumblerLine(i)) return false;
      return ids.has(Number(i.product_id));
    });
  }

  function getCustomTumblerLine(items) {
    return (items || []).find(isCustomTumblerLine) || null;
  }

  function setCustomTumblerError(msg) {
    const el = $('FcCustomTumblerError');
    if (!el) return;
    if (!msg) {
      el.hidden = true;
      el.textContent = '';
      return;
    }
    el.hidden = false;
    el.textContent = msg;
  }

  function updateCustomTumblerCount() {
    const input = $('FcCustomTumblerName');
    const countEl = $('FcCustomTumblerCount');
    if (!input || !countEl) return;
    const max = Number(CT.maxChars) || 16;
    countEl.textContent = input.value.length + '/' + max;
  }

  function ctPriceCents() {
    const n = Number(CT && CT.price);
    return Number.isFinite(n) ? n : 0;
  }

  function ctPriceText() {
    return fmt(ctPriceCents());
  }

  /** Replace {price} / legacy ₹150 in theme copy with live product price */
  function ctCopyWithPrice(template, fallbackPrefix) {
    const price = ctPriceText();
    const raw = String(template || '').trim();
    if (!raw) return (fallbackPrefix || '') + price;
    if (raw.indexOf('{price}') !== -1) return raw.split('{price}').join(price);
    /* Old theme settings often hardcode ₹150 — swap any currency amount for live price */
    if (/[₹$€£]\s?\d[\d,]*(?:\.\d+)?/.test(raw)) {
      return raw.replace(/[₹$€£]\s?\d[\d,]*(?:\.\d+)?/g, price);
    }
    return raw;
  }

  function ctCtaLabel() {
    return ctCopyWithPrice(CT && CT.ctaLabel, 'Add for ');
  }

  function ctSubtitle() {
    return ctCopyWithPrice(CT && CT.subtitle, 'Add your name for ');
  }

  function normalizeAjaxPrice(value) {
    if (value == null || value === '') return null;
    if (typeof value === 'number' && Number.isFinite(value)) {
      /* product.js usually returns cents as int; treat tiny values as major units */
      return value < 1000 && String(value).indexOf('.') !== -1 ? Math.round(value * 100) : value;
    }
    const s = String(value).trim();
    if (!s) return null;
    if (s.indexOf('.') !== -1) return Math.round(parseFloat(s) * 100);
    const n = parseInt(s, 10);
    return Number.isFinite(n) ? n : null;
  }

  let _ctPriceFetch = null;
  function refreshCustomTumblerPrice() {
    if (!CT || !CT.handle || !CT.variantId) return Promise.resolve(ctPriceCents());
    if (_ctPriceFetch) return _ctPriceFetch;
    _ctPriceFetch = fetch('/products/' + encodeURIComponent(CT.handle) + '.js', { cache: 'no-store' })
      .then(function(r) { return r.ok ? r.json() : null; })
      .then(function(product) {
        if (!product) return ctPriceCents();
        const variants = product.variants || [];
        const variant =
          variants.find(function(v) { return Number(v.id) === Number(CT.variantId); }) ||
          variants[0];
        const cents = normalizeAjaxPrice(variant && variant.price != null ? variant.price : product.price);
        if (cents != null) CT.price = cents;
        if (variant && typeof variant.available === 'boolean') CT.available = variant.available;
        return ctPriceCents();
      })
      .catch(function() { return ctPriceCents(); })
      .finally(function() { _ctPriceFetch = null; });
    return _ctPriceFetch;
  }

  function paintCustomTumblerOffer() {
    const box = EL.customTumbler;
    if (!box || box.hidden) return;

    const media = $('FcCustomTumblerMedia');
    const title = $('FcCustomTumblerTitle');
    const sub = $('FcCustomTumblerSub');
    const eyebrow = $('FcCustomTumblerEyebrow');
    const label = $('FcCustomTumblerNameLabel');
    const input = $('FcCustomTumblerName');
    const btn = $('FcCustomTumblerBtn');
    const hint = $('FcCustomTumblerHint');

    if (eyebrow) eyebrow.textContent = CT.eyebrow || 'Bundle exclusive';
    if (title) title.textContent = CT.heading || 'Personalise your free tumbler';
    if (sub) sub.textContent = ctSubtitle();
    if (label) label.textContent = CT.nameLabel || 'Name on tumbler';
    if (btn) {
      btn.textContent = ctCtaLabel();
      btn.disabled = CT.available === false;
    }
    if (hint) {
      hint.textContent = CT.available === false
        ? 'Currently unavailable'
        : ('Printed on your free tumbler · ' + ctPriceText());
    }
    if (input) {
      input.maxLength = Number(CT.maxChars) || 16;
      input.placeholder = CT.namePlaceholder || 'e.g. Priya';
    }
    if (media) {
      media.innerHTML = CT.image
        ? `<img src="${CT.image}" alt="" loading="lazy">`
        : '';
    }
    updateCustomTumblerCount();
  }

  function renderCustomTumblerOffer(cart) {
    const box = EL.customTumbler;
    if (!box) return;

    /* Default: always hide unless a selected bundle product is in cart */
    box.hidden = true;

    if (!CT || !CT.enabled || !CT.variantId) return;
    if (getCustomTumblerBundleIdSet().size === 0) return;

    const items = cart?.items || [];
    if (!cartHasCustomTumblerBundle(items)) return;
    if (getCustomTumblerLine(items)) return;

    setCustomTumblerError('');
    box.hidden = false;
    paintCustomTumblerOffer();
    refreshCustomTumblerPrice().then(function() {
      if (!box.hidden) paintCustomTumblerOffer();
    });
  }

  async function syncCustomTumbler(cart) {
    if (!CT || !CT.enabled || !CT.variantId) return cart;
    const items = cart?.items || [];
    const line = getCustomTumblerLine(items);
    if (!line) return cart;
    if (cartHasCustomTumblerBundle(items)) {
      /* Keep qty at 1 */
      if (line.quantity > 1) {
        try {
          const res = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: line.key, quantity: 1 })
          });
          if (res.ok) return await res.json();
        } catch (e) {}
      }
      return cart;
    }
    /* Bundle removed → drop custom tumbler */
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: line.key, quantity: 0 })
      });
      if (res.ok) return await res.json();
    } catch (e) {}
    return cart;
  }

  window.fcAddCustomTumbler = async function() {
    if (!CT || !CT.enabled || !CT.variantId) return;
    const input = $('FcCustomTumblerName');
    const btn = $('FcCustomTumblerBtn');
    const raw = (input && input.value ? input.value : '').trim().replace(/\s+/g, ' ');
    const max = Number(CT.maxChars) || 16;

    if (!cartHasCustomTumblerBundle(_cart?.items || [])) {
      setCustomTumblerError('Add a bundle to unlock this offer.');
      return;
    }
    if (CT.available === false) {
      setCustomTumblerError('This product is currently unavailable.');
      return;
    }
    if (!raw) {
      setCustomTumblerError('Please enter the name for the tumbler.');
      if (input) input.focus();
      return;
    }
    if (raw.length > max) {
      setCustomTumblerError('Name must be ' + max + ' characters or less.');
      return;
    }
    if (getCustomTumblerLine(_cart?.items || [])) {
      setCustomTumblerError('Custom tumbler is already in your cart.');
      return;
    }

    setCustomTumblerError('');
    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Adding…';
    }
    _cartUpdating = true;
    updateCheckout(0, 0);

    try {
      await refreshCustomTumblerPrice();

      const props = {};
      props[CT_PROP] = raw;
      props[CT_FLAG] = 'true';

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{
            id: Number(CT.variantId),
            quantity: 1,
            properties: props
          }]
        })
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        throw new Error(
          (data && (data.description || data.message)) ||
          'Could not add custom tumbler'
        );
      }
      const cartRes = await fetch('/cart.js', { cache: 'no-store' });
      let cart = await cartRes.json();
      cart = await syncCustomTumbler(cart);
      _cart = cart;
      renderCart(cart);
      if (input) input.value = '';
      updateCustomTumblerCount();
    } catch (e) {
      setCustomTumblerError(e.message || 'Something went wrong. Try again.');
    } finally {
      _cartUpdating = false;
      if (btn) {
        btn.disabled = CT.available === false;
        btn.textContent = ctCtaLabel();
      }
      const items = _cart?.items || [];
      const total = cartValueEx(items);
      const count = items.filter(i => !isFreebieItem(i)).length;
      updateCheckout(total, count);
    }
  };

  function initCustomTumblerField() {
    const input = $('FcCustomTumblerName');
    const btn = $('FcCustomTumblerBtn');
    if (input) {
      input.addEventListener('input', function() {
        updateCustomTumblerCount();
        setCustomTumblerError('');
      });
      input.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          window.fcAddCustomTumbler();
        }
      });
    }
    if (btn) btn.addEventListener('click', function() { window.fcAddCustomTumbler(); });
  }

  // ─── FREEBIE HELPERS ──────────────────────────────────────────────────────
  // Only show as freebie (FREE tag + Rs 0) when cart actually has final price 0. Otherwise checkout charges full price and customer is surprised.
  function isFreebieItem(item) {
    return item.final_price === 0 || (item.final_line_price !== undefined && item.final_line_price === 0);
  }

  function gokwikSafe3kgGiftProperties() {
    return { [SUPR_3KG_GIFT_PROP]: SUPR_3KG_GIFT_VAL };
  }

  function lineHasFreebieFlag(item) {
    const p = item.properties;
    if (!p) return false;
    if (Array.isArray(p)) {
      return p.some(
        (x) =>
          x &&
          ((x.name === '_is_freebie' && String(x.value) === 'true') ||
            (x.name === '_supr_gift' && String(x.value) === 'true') ||
            (x.name === SUPR_3KG_GIFT_PROP && String(x.value) === SUPR_3KG_GIFT_VAL))
      );
    }
    return (
      String(p._is_freebie) === 'true' ||
      String(p._supr_gift) === 'true' ||
      String(p[SUPR_3KG_GIFT_PROP] || '') === SUPR_3KG_GIFT_VAL
    );
  }

  /** GoKwik drops lines whose only properties start with `_`; 3 kg mug uses a visible property. */
  function freebieLineProperties(f) {
    const id = String(f.id);
    if (getVariantRuleOnlyFreebieIds().has(id)) {
      return gokwikSafe3kgGiftProperties();
    }
    return { _is_freebie: 'true' };
  }

  function variantGiftLineNeedsGokwikProperties(item) {
    const variantOnly = getVariantRuleOnlyFreebieIds();
    const vid = String(item?.variant_id);
    if (!variantOnly.has(vid)) return false;
    const p = item.properties;
    if (!p || (Array.isArray(p) && p.length === 0)) return true;
    if (Array.isArray(p)) {
      const hasVisible = p.some(
        (x) => x && x.name === SUPR_3KG_GIFT_PROP && String(x.value) === SUPR_3KG_GIFT_VAL
      );
      const hasHidden = p.some(
        (x) => x && String(x.name || '').charAt(0) === '_'
      );
      return hasHidden || !hasVisible;
    }
    const hasVisible = String(p[SUPR_3KG_GIFT_PROP] || '') === SUPR_3KG_GIFT_VAL;
    const hasHidden = Object.keys(p).some((k) => k.charAt(0) === '_');
    return hasHidden || !hasVisible;
  }

  async function prepareVariantGiftsForGokwikCheckout(cart) {
    if (!cart?.items?.length) return cart;
    let changed = false;
    for (const item of cart.items) {
      if (!variantGiftLineNeedsGokwikProperties(item)) continue;
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: item.key,
          quantity: item.quantity,
          properties: gokwikSafe3kgGiftProperties()
        })
      });
      if (res.ok) changed = true;
    }
    if (!changed) return cart;
    const fresh = await fetch('/cart.js', { cache: 'no-store' });
    return fresh.json();
  }

  function getSuprVariantFreebieRules() {
    if (Array.isArray(window.__SUPR_VARIANT_FREEBIE_RULES__) && window.__SUPR_VARIANT_FREEBIE_RULES__.length) {
      return window.__SUPR_VARIANT_FREEBIE_RULES__;
    }
    try {
      const stored = window.sessionStorage.getItem('supr-variant-freebie-rules');
      if (stored) return JSON.parse(stored);
    } catch (e) {}
    return [];
  }

  function getVariantRuleFreebiesList() {
    return getSuprVariantFreebieRules().flatMap((r) => r.freebies || []);
  }

  let _variantFreebieMetaPromise = null;
  const _runtimeFreebieMetaByVariant = new Map();

  function productHandleFromUrl(url) {
    if (!url) return '';
    const match = String(url).match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function freebieImageCandidate(...values) {
    for (const value of values) {
      if (value && String(value).trim()) return String(value).trim();
    }
    return '';
  }

  async function fetchProductVariantImage(handle, variantId) {
    if (!handle) return null;
    try {
      const res = await fetch(`/products/${encodeURIComponent(handle)}.js`, { credentials: 'same-origin' });
      if (!res.ok) return null;
      const product = await res.json();
      const vid = Number(variantId);
      const variant = (product.variants || []).find((v) => Number(v.id) === vid);
      let image =
        variant?.featured_image?.src ||
        product.featured_image ||
        (Array.isArray(product.images) && product.images[0]);
      if (image && typeof image === 'object') image = image.src || '';
      return {
        title: product.title || '',
        image: typeof image === 'string' ? image : ''
      };
    } catch (error) {
      return null;
    }
  }

  async function enrichFreebieEntry(f, fallbackHandle) {
    const id = Number(f.id);
    if (!id) return false;
    const hasImage = !!freebieImageCandidate(f.image);
    const hasTitle = !!(f.title && f.title !== 'Free gift');
    if (hasImage && hasTitle) return false;

    const handle = f.handle || f.product_handle || fallbackHandle || '';
    if (handle) {
      const meta = await fetchProductVariantImage(handle, id);
      if (meta) {
        if (!hasTitle && meta.title) f.title = meta.title;
        if (!hasImage && meta.image) f.image = meta.image;
        return !!(meta.title || meta.image);
      }
    }

    try {
      const res = await fetch(`/variants/${id}.js`, { credentials: 'same-origin' });
      if (!res.ok) return false;
      const v = await res.json();
      let label = v.name || v.title || f.title || '';
      if (label.indexOf(' - ') > 0) label = label.split(' - ')[0].trim();
      if (!hasTitle && label) f.title = label;
      if (!hasImage && v.featured_image && v.featured_image.src) f.image = v.featured_image.src;
      return true;
    } catch (error) {
      return false;
    }
  }

  /** Fill missing title/image on variant-rule freebies (brew 3 kg mug, etc.). */
  function ensureVariantFreebieMeta(force = false, cart = null) {
    if (_variantFreebieMetaPromise && !force) return _variantFreebieMetaPromise;
    _variantFreebieMetaPromise = (async () => {
      const rules = getSuprVariantFreebieRules();
      let dirty = false;
      for (const rule of rules) {
        for (const f of rule.freebies || []) {
          if (await enrichFreebieEntry(f)) dirty = true;
        }
      }

      for (const item of (cart?.items || []).filter(isFreebieItem)) {
        const id = Number(item.variant_id);
        if (!id) continue;
        let cfg = getFreebieConfigByVariantId(id);
        const handle = cfg?.handle || productHandleFromUrl(item.url);
        if (!cfg && handle) {
          cfg = { id, title: item.product_title, image: item.image, url: item.url, handle };
          _runtimeFreebieMetaByVariant.set(id, cfg);
        }
        if (cfg && !freebieImageCandidate(cfg.image, item.image)) {
          if (await enrichFreebieEntry(cfg, handle)) {
            dirty = true;
            _runtimeFreebieMetaByVariant.set(id, cfg);
          }
        }
      }

      if (dirty && rules.length) {
        window.__SUPR_VARIANT_FREEBIE_RULES__ = rules;
        try {
          window.sessionStorage.setItem('supr-variant-freebie-rules', JSON.stringify(rules));
        } catch (error) {
          /* private mode */
        }
      }
    })();
    return _variantFreebieMetaPromise;
  }

  function getVariantRuleOnlyFreebieIds() {
    const ids = new Set();
    getVariantRuleFreebiesList().forEach((f) => {
      const id = String(f.id);
      if (id) ids.add(id);
    });
    return ids;
  }

  function applyVariantFreebieRules(items, eligible) {
    const rules = getSuprVariantFreebieRules();
    if (!rules.length) return eligible;
    const seen = new Set(eligible.map((f) => String(f.id)));
    const result = [...eligible];
    rules.forEach((rule) => {
      const productId = Number(rule.triggerProductId);
      const variantIds = new Set((rule.triggerVariantIds || []).map(String));
      const matched = (items || []).some(
        (item) =>
          !isFreebieItem(item) &&
          Number(item.product_id) === productId &&
          variantIds.has(String(item.variant_id))
      );
      if (!matched) return;
      (rule.freebies || []).forEach((f) => {
        const id = String(f.id);
        if (!seen.has(id)) {
          seen.add(id);
          result.push(f);
        }
      });
    });
    return result;
  }

  function getOurFreebieVariantIds() {
    const ids = new Set();
    if (!CFG) return ids;
    CFG.fallbackFreebies?.forEach((f) => ids.add(String(f.id)));
    CFG.mappings?.forEach((m) => m.freebies?.forEach((f) => ids.add(String(f.id))));
    getVariantRuleFreebiesList().forEach((f) => ids.add(String(f.id)));
    return ids;
  }

  /** Config entry for a freebie variant (includes bundle_images from product metafield). */
  function getFreebieConfigByVariantId(variantId) {
    const id = Number(variantId);
    const lists = [
      ...(CFG.fallbackFreebies || []),
      ...(CFG.mappings || []).flatMap(m => m.freebies || []),
      ...getVariantRuleFreebiesList()
    ];
    for (let i = 0; i < lists.length; i++) {
      if (Number(lists[i].id) === id) return lists[i];
    }
    return _runtimeFreebieMetaByVariant.get(id) || null;
  }

  function mergeFreebieLineFromConfig(item) {
    const cfg = getFreebieConfigByVariantId(item.variant_id);
    if (!cfg) return item;
    return {
      ...item,
      image: freebieImageCandidate(item.image, cfg.image),
      product_title: item.product_title || cfg.title || item.product_title,
      url: item.url || cfg.url || item.url
    };
  }

  const FC_BUNDLE_TICK_SVG = '<span class="fc-bundle-tick" aria-hidden="true"><svg width="11" height="11" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 5.5L7.5 13 3 8.5" stroke="#16a34a" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';

  function freebieHasBundleImages(item) {
    const cfg = getFreebieConfigByVariantId(item.variant_id);
    return !!(cfg && Array.isArray(cfg.bundle_images) && cfg.bundle_images.filter(Boolean).length);
  }

  /** One line item, horizontal thumbnails + green tick — custom.bundle_cart_images on the freebie product. */
  function buildFreebieImageWrap(item) {
    const cfg = getFreebieConfigByVariantId(item.variant_id);
    let urls = (cfg && Array.isArray(cfg.bundle_images) && cfg.bundle_images.length)
      ? cfg.bundle_images.filter(Boolean)
      : [];
    const safeAlt = String(item.product_title || '').replace(/"/g, '&quot;');
    if (urls.length === 0) {
      const imgSrc = freebieImageCandidate(item.image, cfg?.image);
      return imgSrc
        ? `<div class="fc-img-wrap"><img src="${imgSrc.replace(/"/g, '&quot;')}" alt="${safeAlt}" loading="lazy"></div>`
        : '<div class="fc-img-wrap"></div>';
    }
    let cells = [];
    if (urls.length <= 4) {
      urls.forEach(u => { cells.push({ t: 'img', src: u }); });
    } else {
      urls.slice(0, 3).forEach(u => { cells.push({ t: 'img', src: u }); });
      cells.push({ t: 'more', n: urls.length - 3 });
    }
    const inner = cells.map(c => {
      if (c.t === 'img') {
        return `<div class="fc-bundle-cell"><img src="${c.src}" alt="" loading="lazy">${FC_BUNDLE_TICK_SVG}</div>`;
      }
      return `<div class="fc-bundle-cell fc-bundle-more" aria-hidden="true">${c.n} more</div>`;
    }).join('');
    return `<div class="fc-freebie-bundle-block"><div class="fc-bundle-strip">${inner}</div></div>`;
  }

  function cartValueEx(items) {
    return (items || []).reduce((s, i) => isFreebieItem(i) ? s : s + i.final_line_price, 0);
  }

  function getTriggerPids(items) {
    const triggerIds = new Set(
      (CFG.mappings || []).map(m => Number(m.triggerProductId))
    );
    return (items || [])
      .filter(i => !isFreebieItem(i) && triggerIds.has(Number(i.product_id)))
      .map(i => Number(i.product_id));
  }

  function getEligibleFreebies(items) {
    const triggerPids = getTriggerPids(items);
    const seen = new Set(); const result = [];
    if (triggerPids.length > 0) {
      triggerPids.forEach(pid => {
        const m = CFG.mappings?.find(x => Number(x.triggerProductId) === Number(pid));
        (m?.freebies || []).forEach(f => { if (!seen.has(f.id)) { seen.add(f.id); result.push(f); } });
      });
    } else {
      (CFG.fallbackFreebies || []).forEach(f => { if (!seen.has(f.id)) { seen.add(f.id); result.push(f); } });
    }
    const variantOnlyIds = getVariantRuleOnlyFreebieIds();
    const base = variantOnlyIds.size
      ? result.filter((f) => !variantOnlyIds.has(String(f.id)))
      : result;
    return applyVariantFreebieRules(items, base);
  }

  function resolveEligibleFreebies(items, meetsMin) {
    if (!CFG) return applyVariantFreebieRules(items, []);
    if (meetsMin) return getEligibleFreebies(items);
    return applyVariantFreebieRules(items, []);
  }

  function hasActiveFreebieSyncConfig() {
    return (
      (CFG && (CFG.mappings?.length || CFG.fallbackFreebies?.length)) ||
      getSuprVariantFreebieRules().length > 0
    );
  }

  /** Cart lines after applying /cart/update.js style quantity map (0 = removed). */
  function simulateCartAfterQtyUpdates(items, updates) {
    const out = [];
    for (const i of items || []) {
      if (!updates || !Object.prototype.hasOwnProperty.call(updates, i.key)) {
        out.push(i);
        continue;
      }
      const q = updates[i.key];
      if (q <= 0) continue;
      out.push({ ...i, quantity: q });
    }
    return out;
  }

  function isOurManagedFreebieLine(item) {
    const ourFreebieIds = getOurFreebieVariantIds();
    if (!item || !ourFreebieIds.has(Number(item.variant_id))) return false;
    return isFreebieItem(item) || lineHasFreebieFlag(item);
  }

  function getOurManagedFreebieLineKeys(items) {
    return (items || []).filter(isOurManagedFreebieLine).map(i => i.key);
  }

  /** Keys for our managed freebie lines that should not be in cart for this line-item set (e.g. trigger removed). */
  function getIneligibleManagedFreebieKeys(items) {
    if (!hasActiveFreebieSyncConfig()) return [];
    if (CFG?.freebieImageOnly) {
      return (items || [])
        .filter(i => isOurManagedFreebieLine(i) && !isProtectedVariantGiftLine(i, items))
        .map(i => i.key);
    }
    const cartValue = cartValueEx(items);
    const meetsMin = cartValue >= (CFG?.minCartValue || 0);
    const eligible = resolveEligibleFreebies(items, meetsMin);
    const eligibleIds = new Set(eligible.map((f) => String(f.id)));
    const ourFreebieIds = getOurFreebieVariantIds();
    const keys = [];
    for (const i of items || []) {
      const isOurFreebieLine =
        (isFreebieItem(i) || lineHasFreebieFlag(i)) && ourFreebieIds.has(String(i.variant_id));
      if (!isOurFreebieLine) continue;
      if (!eligibleIds.has(String(i.variant_id))) {
        if (isProtectedVariantGiftLine(i, items)) continue;
        keys.push(i.key);
      }
    }
    return keys;
  }

  function expandUpdatesWithFreebieRemovals(items, updates) {
    if (!updates || typeof updates !== 'object') return updates;
    const merged = { ...updates };
    const sim = simulateCartAfterQtyUpdates(items, merged);
    getIneligibleManagedFreebieKeys(sim).forEach(k => { merged[k] = 0; });
    return merged;
  }

  // ─── OPEN / CLOSE ─────────────────────────────────────────────────────────
  window.openSuprCart = function(previousUrlOverride) {
    portalCartDrawerToBody();
    // Store current URL before opening (unless we're already on a replaced URL)
    const currentPath = window.location.pathname;
    // Only store if it's a real page (not root which might be replaced from /cart)
    if (currentPath !== '/' || !_previousUrl) {
      // Don't store /cart as previous URL - we want to go back to product page
      if (currentPath !== '/cart' && currentPath !== '/cart/') {
        _previousUrl = currentPath;
      }
    }
    // Allow override from interceptor (when coming from /cart redirect or form submission)
    if (previousUrlOverride && previousUrlOverride !== '/cart' && previousUrlOverride !== '/cart/') {
      _previousUrl = previousUrlOverride;
    }
    document.body.classList.add('fc-open');
    fetchCart();
  };
  
  // Method to set previous URL from external code (used by interceptor)
  window.openSuprCart.setPreviousUrl = function(url) {
    if (url && url !== '/cart' && url !== '/cart/' && url !== '/') {
      _previousUrl = url;
    }
  };
  window.closeSuprCart = function() {
    document.body.classList.remove('fc-open');
    
    // Dispatch event to notify global interceptor that drawer is closing
    document.dispatchEvent(new CustomEvent('supr:drawer:closing'));
    
    // Restore previous URL - prioritize stored URL, then check current location
    const currentPath = window.location.pathname;
    
    // If we have a stored previous URL, restore it
    if (_previousUrl && _previousUrl !== '/' && _previousUrl !== '/cart' && _previousUrl !== '/cart/') {
      // Only restore if we're currently on root or cart (which shouldn't happen now)
      if (currentPath === '/' || currentPath === '/cart' || currentPath === '/cart/') {
        window.history.replaceState({}, '', _previousUrl);
      }
      _previousUrl = null;
    } else if (currentPath === '/' || currentPath === '/cart' || currentPath === '/cart/') {
      // If we're on root or cart with no stored URL, try to get it from referrer
      const referrer = document.referrer;
      if (referrer) {
        try {
          const referrerUrl = new URL(referrer);
          const referrerPath = referrerUrl.pathname;
          // Only use referrer if it's a valid product/page URL
          if (referrerPath !== '/cart' && referrerPath !== '/cart/' && referrerPath !== '/') {
            window.history.replaceState({}, '', referrerPath);
          }
        } catch (e) {
          // Invalid referrer, ignore
        }
      }
    }
  };

  function getGiftNoteEl() {
    return document.getElementById('FcGiftNote');
  }

  function currentGiftNote() {
    const el = getGiftNoteEl();
    return el ? el.value.trim() : '';
  }

  function updateGiftNoteMeta(note) {
    const hidden = document.getElementById('FcCheckoutNote');
    if (hidden) hidden.value = note;
    const hint = document.getElementById('FcGiftNoteHint');
    const el = getGiftNoteEl();
    if (hint && el) {
      const max = parseInt(el.getAttribute('maxlength') || '250', 10);
      hint.textContent = note.length + '/' + max;
    }
  }

  function syncGiftNoteFromCart(cart) {
    const el = getGiftNoteEl();
    const note = (cart && cart.note) ? String(cart.note) : '';
    const hasUnsaved = el && el.value.trim() !== String(_lastSavedGiftNote || '').trim();
    if (!hasUnsaved) _lastSavedGiftNote = note;
    if (el && !hasUnsaved && document.activeElement !== el) {
      el.value = note;
    }
    updateGiftNoteMeta(el ? el.value : note);
  }

  function flushGiftNoteToCart() {
    const note = currentGiftNote();
    updateGiftNoteMeta(note);
    if (note === _lastSavedGiftNote) return _giftNotePromise;
    _giftNotePromise = fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: note })
    }).then(function(res) {
      if (!res.ok) throw new Error('note save failed');
      _lastSavedGiftNote = note;
    }).catch(function() {});
    return _giftNotePromise;
  }

  function scheduleGiftNoteSave() {
    updateGiftNoteMeta(currentGiftNote());
    clearTimeout(_giftNoteTimer);
    _giftNoteTimer = setTimeout(flushGiftNoteToCart, 400);
  }

  function initGiftNoteField() {
    const el = getGiftNoteEl();
    if (!el) return;
    updateGiftNoteMeta(el.value);
    el.addEventListener('input', scheduleGiftNoteSave);
    el.addEventListener('change', flushGiftNoteToCart);
    el.addEventListener('blur', flushGiftNoteToCart);
  }

  // ─── FETCH & RENDER ───────────────────────────────────────────────────────
  async function fetchCart(force = false) {
    const wasUpdating = _cartUpdating;
    if (!wasUpdating) {
      _cartUpdating = true;
      updateCheckout(0, 0); // Disable checkout immediately
    }
    try {
      const res = await fetch('/cart.js', { cache: 'no-store' });
      let cart = await res.json();
      await ensureVariantFreebieMeta(false, cart);
      // Ensure our managed freebies have max quantity 1 (only if needed)
      const freebies = (cart.items || []).filter(isFreebieItem);
      const ourIds = getOurFreebieVariantIds();
      const invalidQty = freebies.filter(i => ourIds.has(i.variant_id) && i.quantity > 1);
      if (invalidQty.length > 0) {
        cart = await enforceFreebieQuantity(cart);
      }
      cart = await enforceFreebieQuantity(cart);
      cart = await ensureVariantRuleFreebiesInCart(cart);
      _cart = cart;
      syncGiftNoteFromCart(cart);
      renderCart(cart, true);
      syncFreebiesLocal(cart, true).then(() => {
        // Fetch fresh cart after sync completes
        fetch('/cart.js', { cache: 'no-store' }).then(r => r.json()).then(async freshCart => {
          await ensureVariantFreebieMeta(true, freshCart);
          freshCart = await syncCustomTumbler(freshCart);
          _cart = freshCart;
          // Always re-render with actual freebies (optimistic ones will be replaced with real ones)
          // This ensures smooth transition from optimistic to actual freebies
          renderCart(freshCart, false);
          if (!wasUpdating && !_freebieSyncing) {
            _cartUpdating = false;
            const items = freshCart.items || [];
            const total = cartValueEx(items);
            const count = items.filter(i => !isFreebieItem(i)).length;
            updateCheckout(total, count);
          }
        });
      }).catch(() => {
        if (!wasUpdating) {
          _cartUpdating = false;
          const items = _cart?.items || [];
          const total = cartValueEx(items);
          const count = items.filter(i => !isFreebieItem(i)).length;
          updateCheckout(total, count);
        }
      });
      
      // Re-enable checkout immediately with current cart state (optimistic)
      if (!wasUpdating && !_freebieSyncing) {
        _cartUpdating = false;
        const items = cart.items || [];
        const total = cartValueEx(items);
        const count = items.filter(i => !isFreebieItem(i)).length;
        updateCheckout(total, count);
      }
      return cart;
    } catch (e) {
      if (!wasUpdating) {
        _cartUpdating = false;
        const items = _cart?.items || [];
        const total = cartValueEx(items);
        const count = items.filter(i => !isFreebieItem(i)).length;
        updateCheckout(total, count);
      }
      throw e;
    }
  }

  function renderCart(cart, showOptimisticFreebies = false) {
    const items = cart.items || [];
    const total = cartValueEx(items);
    const count = items.filter(i => !isFreebieItem(i)).length;

    // Footer count
    EL.footer.textContent = count === 1 ? '1 item' : count + ' items';
    EL.total.textContent  = fmt(total);

    // Freebie banner: only when 1+ products in cart have 0 Rs (discount applied)
    const meetsMin = total >= (CFG?.minCartValue || 0);
    const eligibleFreebies = resolveEligibleFreebies(items, meetsMin);
    const hasFreeGoodies =
      (!CFG.freebieImageOnly && items.some(i => isFreebieItem(i))) ||
      (CFG.freebieImageOnly && meetsMin && eligibleFreebies.length > 0);
    if (hasFreeGoodies) {
      EL.banner.textContent = RUNTIME.freebieMessage || '';
      EL.banner.style.display = 'block';
    } else {
      EL.banner.style.display = 'none';
    }

    // Checkout button state
    updateCheckout(total, count);

    // Items
    if (items.length === 0) {
      EL.items.innerHTML = `
        <div class="fc-empty">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/>
            <path d="M16 10a4 4 0 01-8 0"/>
          </svg>
          <p>Your cart is empty</p>
        </div>`;
      if (EL.upsell) EL.upsell.style.display = 'none';
      renderCustomTumblerOffer(cart);
      updateCheckoutFormAction(cart);
      return;
    }

    const regular  = items.filter(i => !isFreebieItem(i));
    let freebies = items.filter(i =>  isFreebieItem(i)).map(mergeFreebieLineFromConfig);

    if (CFG.freebieImageOnly) {
      const variantOnlyIds = getVariantRuleOnlyFreebieIds();
      freebies = freebies.filter(
        i => variantOnlyIds.has(String(i.variant_id)) || !isOurManagedFreebieLine(i)
      );
      const realFreebieIds = new Set(freebies.map(i => String(i.variant_id)));
      if (meetsMin && eligibleFreebies.length > 0) {
        eligibleFreebies.forEach(f => {
          if (realFreebieIds.has(String(f.id))) return;
          if (variantOnlyIds.has(String(f.id))) return;
          freebies.push({
            key: 'display-freebie-' + f.id,
            variant_id: f.id,
            product_title: f.title,
            final_line_price: 0,
            final_price: 0,
            image: f.image,
            url: f.url,
            quantity: 1,
            variant_title: '',
            properties: [{ name: '_is_freebie', value: 'true' }]
          });
        });
      }
    } else if (showOptimisticFreebies && eligibleFreebies.length > 0) {
      const variantOnly = getVariantRuleOnlyFreebieIds();
      const freebieIdsInCart = new Set(freebies.map((i) => String(i.variant_id)));
      eligibleFreebies.forEach(f => {
        if (variantOnly.has(String(f.id))) return;
        if (!freebieIdsInCart.has(String(f.id))) {
          freebies.push({
            key: 'optimistic-' + f.id,
            variant_id: f.id,
            product_title: f.title,
            final_line_price: 0,
            final_price: 0,
            image: f.image,
            url: f.url,
            quantity: 1,
            variant_title: '',
            properties: [{ name: '_is_freebie', value: 'true' }]
          });
        }
      });
    }

    let html = '';

    regular.forEach(item => { html += buildItemHTML(item, false); });
    freebies.forEach(item => { html += buildItemHTML(item, true); });

    EL.items.innerHTML = html;
    
    // Inject Judge.me review badges (same as product page: product.metafields.judgeme.badge) via Section Rendering API
    injectCartReviewBadges(cart);
    
    // Update upsells after rendering cart (to exclude items now in cart)
    renderUpsells();
    renderCustomTumblerOffer(cart);
    // When cart has upsell products, send checkout with manual discount code so discount applies at checkout
    updateCheckoutFormAction(cart);
  }

  /** Cart UI only: hide long bundle parenthetical on SUPR Special Bundle line items. */
  function formatCartProductTitle(title) {
    const t = String(title || '');
    const suffix = ' (Tumbler+ Shaker+ ToteBag+ Cookies)';
    return t.endsWith(suffix) ? t.slice(0, -suffix.length) : t;
  }

  function buildItemHTML(item, isFreebie) {
    // Resolve original price
    let origPrice = item.original_price > item.final_price ? item.original_price : 0;
    if (!origPrice && isFreebie) {
      const allFreebies = [
        ...(CFG.fallbackFreebies || []),
        ...(CFG.mappings || []).flatMap(m => m.freebies || []),
        ...getVariantRuleFreebiesList()
      ];
      const match = allFreebies.find(f => Number(f.id) === Number(item.variant_id));
      if (match?.original_price > 0) origPrice = match.original_price;
    }

    const compareHTML = origPrice > 0
      ? `<span class="fc-compare">${fmt(origPrice)}</span>` : '';

    const badgeHTML = isFreebie ? '<span class="fc-badge-free">FREE</span>' : '';
    const displayPrice = isFreebie ? fmt(0) : fmt(item.final_line_price);

    const variantLabel = (item.variant_title && item.variant_title !== 'Default Title')
      ? `<div class="fc-variant-title">${item.variant_title}</div>` : '';
    const freebieCfg = isFreebie ? getFreebieConfigByVariantId(item.variant_id) : null;
    let displayTitle = formatCartProductTitle(item.product_title);
    if (isFreebie && freebieCfg?.title && (!displayTitle || displayTitle === 'Free gift')) {
      displayTitle = formatCartProductTitle(freebieCfg.title);
    }
    const isTumblerLine = isCustomTumblerLine(item);
    const isBundleOfferProduct = !!(CT && (CT.bundleProductIds || []).some(function(id) {
      return Number(id) === Number(item.product_id);
    }));
    const titleEl = isFreebie
      ? `<span class="fc-title">${displayTitle}${badgeHTML}</span>`
      : `<a href="${item.url}" class="fc-title">${displayTitle}</a>`;

    // No Judge.me badges on freebies, custom tumbler, or selected bundle products
    const reviewHTML = (isFreebie || isTumblerLine || isBundleOfferProduct)
      ? ''
      : `<div class="fc-item-review" data-product-id="${item.product_id}"></div>`;

    const tumblerName = getLineProperty(item, CT_PROP);
    const propHTML = tumblerName
      ? `<div class="fc-item-prop">${CT_PROP}: <strong>${tumblerName.replace(/</g, '&lt;')}</strong></div>`
      : '';

    const removeBtn = isFreebie ? '' : `
      <button class="fc-remove-btn" onclick="fcRemoveItem('${item.key}')" aria-label="Remove">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
      </button>`;

    const qtyEl = (isFreebie || isTumblerLine) ? '' : `
      <div class="fc-qty">
        <button class="fc-qty-btn" onclick="fcChangeQty('${item.key}', ${item.quantity - 1}, this)">−</button>
        <span class="fc-qty-val" id="qty-${item.key}">${item.quantity}</span>
        <button class="fc-qty-btn" onclick="fcChangeQty('${item.key}', ${item.quantity + 1}, this)">+</button>
      </div>`;

    const imgBlock = isFreebie
      ? buildFreebieImageWrap(item)
      : `<div class="fc-img-wrap"><a href="${item.url}"><img src="${item.image}" alt="${displayTitle}" loading="lazy"></a></div>`;

    const bundleRowClass = isFreebie && freebieHasBundleImages(item) ? ' fc-item-freebie--bundle' : '';

    return `
      <div class="fc-item ${isFreebie ? 'fc-item-freebie' : ''}${bundleRowClass}" id="fc-item-${item.key.replace(/:/g, '-')}"${isFreebie ? '' : ` data-product-id="${item.product_id}"`}>
        ${imgBlock}
        <div class="fc-info">
          <div class="fc-title-row"><div>${titleEl}${variantLabel}${propHTML}${reviewHTML}</div></div>
          <div class="fc-price-row">${compareHTML}<span>${displayPrice}</span></div>
          ${removeBtn}
          ${qtyEl}
        </div>
      </div>`;
  }

  // ─── OPTIMISTIC QTY CHANGE ────────────────────────────────────────────────
  // Updates UI instantly, then debounces API call
  window.fcChangeQty = function(key, newQty, btn) {
    // Optimistic: update display immediately
    const qtyEl = document.getElementById('qty-' + key);
    if (qtyEl && newQty > 0) {
      qtyEl.textContent = newQty;
      // Update price optimistically by finding item and recalculating
      if (_cart) {
        const item = _cart.items.find(i => i.key === key);
        if (item) {
          const priceEl = qtyEl.closest('.fc-info')?.querySelector('.fc-price-row span:last-child');
          if (priceEl) priceEl.textContent = fmt((item.price / item.quantity || item.price) * newQty);
        }
      }
    }

    if (newQty <= 0) {
      // Remove instantly from UI
      fcRemoveItem(key);
      return;
    }

    // Queue debounced API call
    _pendingQtyChanges[key] = newQty;
    clearTimeout(_qtyFlushTimer);
    _qtyFlushTimer = setTimeout(flushQtyChanges, QTY_DEBOUNCE);
  };

  async function flushQtyChanges() {
    if (Object.keys(_pendingQtyChanges).length === 0) return;
    const updates = { ..._pendingQtyChanges };
    Object.keys(_pendingQtyChanges).forEach(k => delete _pendingQtyChanges[k]);

    _cartUpdating = true;
    updateCheckout(0, 0); // Disable checkout immediately
    try {
      const updatesWithFreebies = expandUpdatesWithFreebieRemovals(_cart?.items || [], updates);
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updatesWithFreebies })
      });
      let cart = await res.json();
      // Ensure freebies have max quantity 1
      cart = await enforceFreebieQuantity(cart);
      _cart = cart;
      renderCart(cart);
      // Sync freebies and wait for it to fully complete
      await syncFreebiesLocal(cart);
      // No delay - process immediately
      // Fetch fresh cart to ensure we have the latest state after freebie sync
      const freshRes = await fetch('/cart.js', { cache: 'no-store' });
      const freshCart = await freshRes.json();
      _cart = freshCart;
      renderCart(freshCart);
      // Re-enable checkout with updated cart state (after freebies are removed)
      const items = freshCart.items || [];
      const total = cartValueEx(items);
      const count = items.filter(i => !isFreebieItem(i)).length;
      updateCheckout(total, count);
    } catch (e) {
      // Re-fetch on failure
      await fetchCart();
    } finally {
      _cartUpdating = false;
    }
  }

  // ─── OPTIMISTIC REMOVE ────────────────────────────────────────────────────
  window.fcRemoveItem = function(key) {
    const updates = expandUpdatesWithFreebieRemovals(_cart?.items || [], { [key]: 0 });
    const keysRemoving = Object.keys(updates).filter(k => updates[k] === 0);

    keysRemoving.forEach(k => {
      const el = document.getElementById('fc-item-' + k.replace(/:/g, '-'));
      if (el) el.classList.add('fc-removing');
    });

    // Remove from local state immediately for subtotal update (main line + tied freebies)
    if (_cart) {
      const drop = new Set(keysRemoving);
      _cart.items = _cart.items.filter(i => !drop.has(i.key));
      const total = cartValueEx(_cart.items);
      const count = _cart.items.filter(i => !isFreebieItem(i)).length;
      EL.total.textContent = fmt(total);
      EL.footer.textContent = count + (count === 1 ? ' item' : ' items');
      updateCheckout(total, count);
    }

    // Disable checkout during removal
    _cartUpdating = true;
    updateCheckout(0, 0);
    
    // API call (no wait for UI) — same request removes trigger line and its freebies
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    }).then(r => r.json()).then(async cart => {
      _cart = cart;
      renderCart(cart);
      // Sync freebies and wait for it to fully complete
      await syncFreebiesLocal(cart);
      // No delay - process immediately
      // Fetch fresh cart to ensure we have the latest state after freebie sync
      const freshRes = await fetch('/cart.js', { cache: 'no-store' });
      let freshCart = await freshRes.json();
      freshCart = await syncCustomTumbler(freshCart);
      _cart = freshCart;
      renderCart(freshCart);
      // Re-enable checkout with updated cart state (after freebies are removed)
      if (!_freebieSyncing) {
        _cartUpdating = false;
        const items = freshCart.items || [];
        const total = cartValueEx(items);
        const count = items.filter(i => !isFreebieItem(i)).length;
        updateCheckout(total, count);
      }
    }).catch(() => {
      _cartUpdating = false;
      fetchCart();
    });
  };

  function cartHasVariantId(items, variantId) {
    const id = String(variantId);
    return (items || []).some((i) => String(i.variant_id) === id);
  }

  /** Max qty 1 and one line per managed freebie variant (fixes parallel sync double-add). */
  async function enforceFreebieQuantity(cart) {
    const ourIds = getOurFreebieVariantIds();
    const updates = {};
    const keptVariant = new Set();

    for (const item of cart.items || []) {
      const vid = String(item.variant_id);
      if (!ourIds.has(vid)) continue;
      const managed = isFreebieItem(item) || lineHasFreebieFlag(item);
      if (!managed) continue;
      if (item.quantity > 1) updates[item.key] = 1;
      if (keptVariant.has(vid)) {
        updates[item.key] = 0;
      } else {
        keptVariant.add(vid);
      }
    }

    if (Object.keys(updates).length === 0) return cart;
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    });
    if (res.ok) {
      const fresh = await fetch('/cart.js', { cache: 'no-store' });
      return fresh.json();
    }
    return cart;
  }

  // ─── FREEBIE SYNC (local, fast) ───────────────────────────────────────────
  let _syncLock = false;
  async function syncFreebiesLocal(cart, skipRender = false) {
    if (_syncLock) return;
    if (!hasActiveFreebieSyncConfig()) return;

    if (typeof window.suprSyncFreebies === 'function') {
      try {
        if (window.SUPR_GLOBAL?.isSyncing) {
          while (window.SUPR_GLOBAL?.isSyncing) {
            await new Promise((r) => window.setTimeout(r, 60));
          }
        } else {
          await window.suprSyncFreebies(cart);
        }
        const freshRes = await fetch('/cart.js', { cache: 'no-store' });
        let freshCart = await freshRes.json();
        freshCart = await enforceFreebieQuantity(freshCart);
        _cart = freshCart;
        if (!skipRender) renderCart(freshCart);
        return;
      } catch (e) {
        /* fall through to local sync */
      }
    }

    _syncLock = true;
    const wasUpdating = _cartUpdating;
    if (!wasUpdating) {
      _cartUpdating = true;
      updateCheckout(0, 0); // Disable checkout during sync
    }
    try {
      const items = cart.items || [];
      
    const cartValue = cartValueEx(items);
    const meetsMin  = cartValue >= (CFG?.minCartValue || 0);

    const eligible    = resolveEligibleFreebies(items, meetsMin);
      const ourFreebieIds = getOurFreebieVariantIds();

      const toRemoveKeys = getIneligibleManagedFreebieKeys(items);
      const toRemove = toRemoveKeys.map(k => items.find(i => i.key === k)).filter(Boolean);
      const variantOnlyIds = getVariantRuleOnlyFreebieIds();
      const toAdd = eligible.filter((f) => {
        if (cartHasVariantId(items, f.id)) return false;
        return CFG.freebieImageOnly ? variantOnlyIds.has(String(f.id)) : true;
      });

      if (toRemove.length === 0 && toAdd.length === 0) {
        if (!wasUpdating) {
          _cartUpdating = false;
          const total = cartValueEx(items);
          const count = items.filter(i => !isFreebieItem(i)).length;
          updateCheckout(total, count);
        }
        return;
      }

      // ── Batch remove ──────────────────────────────────────────────────────
      if (toRemove.length > 0) {
        // Ensure checkout is disabled during removal
        if (!wasUpdating) {
          _cartUpdating = true;
          updateCheckout(0, 0);
        }
        const updates = {};
        toRemove.forEach(i => { updates[i.key] = 0; });
        const res = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        });
        cart = await res.json();
        // Ensure freebies have max quantity 1
        cart = await enforceFreebieQuantity(cart);
        _cart = cart;
        // No delay - process immediately
        // Fetch fresh cart to ensure we have the latest state
        const freshRes = await fetch('/cart.js', { cache: 'no-store' });
        const freshCart = await freshRes.json();
        _cart = freshCart;
        // Re-evaluate after removal (use our variant IDs in cart, not price, to avoid re-add loop)
        const itemsAfter  = freshCart.items || [];
        const freshEligible = resolveEligibleFreebies(
          itemsAfter,
          cartValueEx(itemsAfter) >= (CFG?.minCartValue || 0)
        );
        const toAddFinal = freshEligible.filter((f) => {
          if (cartHasVariantId(itemsAfter, f.id)) return false;
          return CFG.freebieImageOnly ? variantOnlyIds.has(String(f.id)) : true;
        });
        if (toAddFinal.length > 0) {
          // Keep checkout disabled while adding freebies
          await batchAddFreebies(toAddFinal, skipRender);
        } else {
          // Only render if not skipping (to avoid flicker)
          if (!skipRender) {
            renderCart(freshCart);
          }
          // Re-enable checkout after removal completes
          if (!wasUpdating && !_freebieSyncing) {
            _cartUpdating = false;
            const total = cartValueEx(itemsAfter);
            const count = itemsAfter.filter(i => !isFreebieItem(i)).length;
            updateCheckout(total, count);
          }
        }
        return;
      }

      // ── Batch add ─────────────────────────────────────────────────────────
      if (toAdd.length > 0) {
        await batchAddFreebies(toAdd, skipRender);
      }
    } finally {
      // Only re-enable checkout if we weren't already updating and global freebie sync isn't active
      if (!wasUpdating && !_freebieSyncing) {
        _cartUpdating = false;
        const items = _cart?.items || [];
        const total = cartValueEx(items);
        const count = items.filter(i => !isFreebieItem(i)).length;
        updateCheckout(total, count);
      }
      // Remove sync lock immediately (no cooldown)
      _syncLock = false;
    }
  }

  let _batchFreebieAddChain = Promise.resolve();

  async function batchAddFreebies(freebies, skipRender = false) {
    const run = async () => {
    const wasUpdating = _cartUpdating;
    if (!wasUpdating) {
      _cartUpdating = true;
      updateCheckout(0, 0); // Disable checkout during add
    }
    try {
      const freshBefore = await fetch('/cart.js', { cache: 'no-store' });
      const cartBefore = await freshBefore.json();
      const toAdd = (freebies || []).filter((f) => !cartHasVariantId(cartBefore.items, f.id));
      if (!toAdd.length) return;

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: toAdd.map(f => ({
            id: String(f.id),
            quantity: 1,
            properties: freebieLineProperties(f)
          }))
        })
      });
      if (res.ok) {
        const cartRes = await fetch('/cart.js', { cache: 'no-store' });
        let cart = await cartRes.json();
        cart = await enforceFreebieQuantity(cart);
        _cart = cart;
        if (!skipRender) {
          renderCart(cart);
        }
        if (!wasUpdating && !_freebieSyncing) {
          _cartUpdating = false;
          const items = cart.items || [];
          const total = cartValueEx(items);
          const count = items.filter(i => !isFreebieItem(i)).length;
          updateCheckout(total, count);
        }
      } else {
        const err = await res.json().catch(() => ({}));
        console.warn('[SUPR Cart] Could not add free gift line:', err.description || err.message || res.status);
      }
    } finally {
      if (!wasUpdating && !_freebieSyncing) {
        _cartUpdating = false;
      }
    }
    };
    _batchFreebieAddChain = _batchFreebieAddChain.then(run, run);
    return _batchFreebieAddChain;
  }

  // ─── UPSELLS ──────────────────────────────────────────────────────────────
  let _upsellData = null;
  
  function initUpsells() {
    try {
      _upsellData = JSON.parse(document.getElementById('FcUpsellData').textContent);
      renderUpsells();
    } catch (e) {
      EL.upsell.style.display = 'none';
    }
  }

  // ─── CALCULATE DYNAMIC PRICE FOR UPSELL ────────────────────────────────────
  function calculateUpsellPrice(product, cartItems) {
    let finalPrice = product.price;
    let originalPrice = product.compare_at_price || product.price;
    
    // Get cart value (excluding freebies)
    const cartValue = cartValueEx(cartItems);
    
    // Check if cart has any products (excluding freebies)
    const hasProductsInCart = cartItems.filter(i => !isFreebieItem(i)).length > 0;
    
    // Rule 1: Apply discount when any product is in cart
    const generalDiscount = Number(RUNTIME.upsellDiscountPercent) || 0;
    if (hasProductsInCart && generalDiscount > 0) {
      const discount = Math.round(product.price * (generalDiscount / 100));
      finalPrice = product.price - discount;
    }
    
    // Rule 2: Cart value-based discount (takes precedence if better)
    const cartValueThreshold = Number(RUNTIME.upsellCartValueThreshold) || 0;
    const cartValueDiscount = Number(RUNTIME.upsellCartValueDiscount) || 0;
    
    if (cartValue >= cartValueThreshold && cartValueDiscount > 0) {
      const discount = Math.round(product.price * (cartValueDiscount / 100));
      const discountedPrice = product.price - discount;
      // Use the better discount (lower price)
      if (discountedPrice < finalPrice) {
        finalPrice = discountedPrice;
      }
    }
    
    // Ensure price doesn't go below 0
    finalPrice = Math.max(0, finalPrice);
    
    return {
      price: finalPrice,
      originalPrice: originalPrice,
      hasDiscount: finalPrice < product.price
    };
  }

  function renderUpsells() {
    if (!_upsellData || _upsellData.length === 0) {
      EL.upsell.style.display = 'none';
      return;
    }

    // Get current cart items (excluding freebies)
    const cartItems = _cart?.items || [];
    const cartVariantIds = new Set(
      cartItems
        .filter(i => !isFreebieItem(i))
        .map(i => i.variant_id)
    );

    // Filter out products already in cart + the custom tumbler SKU (sold only via offer card)
    const availableUpsells = _upsellData.filter(p => {
      if (cartVariantIds.has(p.id)) return false;
      if (CT && CT.variantId && Number(p.id) === Number(CT.variantId)) return false;
      return true;
    });

    if (availableUpsells.length === 0) {
      EL.upsell.style.display = 'none';
      return;
    }

    EL.upsell.style.display = 'block';
    let html = '';
    
    // Show up to 6 products with dynamic pricing
    availableUpsells.slice(0, 6).forEach(p => {
      // Calculate dynamic price based on cart contents
      const priceInfo = calculateUpsellPrice(p, cartItems);
      
      // Use dynamic price or original price
      const displayPrice = priceInfo.price;
      const comparePrice = priceInfo.hasDiscount ? p.price : (p.compare_at_price || 0);
      
      // Show compare price if there's a discount or original compare_at_price
      const compare = (priceInfo.hasDiscount && comparePrice > displayPrice) || 
                      (!priceInfo.hasDiscount && p.compare_at_price > p.price)
        ? `<span class="fc-up-compare">${fmt(comparePrice)}</span>` : '';
      
      html += `
        <div class="fc-up-card">
          <div class="fc-up-img-wrap">
            <img src="${p.image}" alt="${p.title}" loading="lazy">
          </div>
          <div class="fc-up-body">
          <div>
            <div class="fc-up-title">${p.title}</div>
            <div class="fc-up-price-row">${compare}<span>${fmt(displayPrice)}</span></div>
            </div>
            <button class="fc-up-btn" onclick="fcUpsellAdd(${p.id}, this)">Add to Cart</button>
          </div>
        </div>`;
    });
    
    EL.upsellList.innerHTML = html;
  }

  window.fcUpsellAdd = async function(id, btn) {
    btn.classList.add('fc-adding');
    btn.textContent = '...';
    _cartUpdating = true;
    updateCheckout(0, 0); // Disable checkout during add
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id, quantity: 1 })
      });
      btn.textContent = '✓ Added';
      setTimeout(() => { btn.textContent = 'Add to Cart'; btn.classList.remove('fc-adding'); }, 1500);
      await fetchCart(); // This will re-enable checkout and update upsells
    } catch (e) {
      btn.textContent = 'Retry';
      btn.classList.remove('fc-adding');
      _cartUpdating = false;
      const items = _cart?.items || [];
      const total = cartValueEx(items);
      const count = items.filter(i => !isFreebieItem(i)).length;
      updateCheckout(total, count);
    }
  };

  // ─── REVIEW BADGES (Judge.me, same as product page) ─────────────────────────
  // Uses product.metafields.judgeme.badge from Liquid: in-DOM script (from initial render) or Section Rendering API fetch.
  function parseBadgesFromHtml(html) {
    if (!html || typeof html !== 'string') return null;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const scriptEl = doc.getElementById('fc-cart-review-badges');
    if (!scriptEl || !scriptEl.textContent) return null;
    try { return JSON.parse(scriptEl.textContent.trim()); } catch (e) { return null; }
  }
  function injectBadgesIntoItems(badgesMap, cart) {
    if (!badgesMap || typeof badgesMap !== 'object') return;
    const skipProductIds = new Set(
      [
        CT && CT.productId,
        ...((CT && CT.bundleProductIds) || [])
      ].map(Number).filter(Boolean)
    );
    const regularItems = (cart && cart.items)
      ? cart.items.filter(function(i) {
          return !isFreebieItem(i) && !isCustomTumblerLine(i) && !skipProductIds.has(Number(i.product_id));
        })
      : [];
    regularItems.forEach(function(item) {
      const pid = item.product_id;
      const badgeHtml = badgesMap[pid];
      if (!badgeHtml) return;
      const reviewEl = document.querySelector('.fc-item[data-product-id="' + pid + '"] .fc-item-review');
      if (reviewEl) reviewEl.innerHTML = badgeHtml;
    });
  }
  function injectCartReviewBadges(cart) {
    const regularItems = (cart && cart.items) ? cart.items.filter(function(i) { return !isFreebieItem(i); }) : [];
    if (regularItems.length === 0) return;
    // 1) Use in-DOM script first (badges for cart when page was rendered — works on first open)
    const domScript = document.getElementById('fc-cart-review-badges');
    if (domScript && domScript.textContent) {
      try {
        const badgesMap = JSON.parse(domScript.textContent.trim());
        if (badgesMap && typeof badgesMap === 'object') injectBadgesIntoItems(badgesMap, cart);
      } catch (e) {}
    }
    // 2) Fetch section to get current cart badges (Section Rendering API; response key may vary)
    const drawer = document.getElementById('FcDrawer');
    const sectionId = drawer && drawer.dataset.sectionId;
    if (!sectionId) return;
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const url = root + (root.indexOf('?') !== -1 ? '&' : '?') + 'sections=' + encodeURIComponent(sectionId);
    fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        const sections = data.sections || {};
        let sectionHtml = sections[sectionId];
        if (!sectionHtml && typeof sections === 'object') {
          for (var k in sections) { if (sections[k] && sections[k].indexOf('fc-cart-review-badges') !== -1) { sectionHtml = sections[k]; break; } }
        }
        if (!sectionHtml) return;
        const badgesMap = parseBadgesFromHtml(sectionHtml);
        if (badgesMap) injectBadgesIntoItems(badgesMap, cart);
      })
      .catch(function() {});
  }

  function getBrewMugDiscountCode() {
    let code = '';
    try {
      code = window.sessionStorage.getItem('supr-brew-mug-discount-code') || '';
    } catch (e) {}
    if (!code) {
      try {
        const el = document.getElementById('SbpSelfStirMugConfig');
        if (el && el.textContent) {
          code = JSON.parse(el.textContent).discountCode || '';
        }
      } catch (e2) {}
    }
    code = String(code || '').trim();
    if (code.toLowerCase() === 'none') return '';
    return code;
  }

  function cartHasBrewMugGiftLine(cart) {
    const mugIds = getVariantRuleOnlyFreebieIds();
    if (!mugIds.size) return false;
    return (cart?.items || []).some((i) => mugIds.has(String(i.variant_id)));
  }

  /** Shopify automatic discounts recalc on cart refresh; nudge after freebie adds. */
  async function refreshCartDiscounts(cart) {
    const items = cart?.items || _cart?.items || [];
    const paid = items.find((i) => !isFreebieItem(i));
    if (!paid) return cart;
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: paid.key, quantity: paid.quantity })
      });
      if (res.ok) return await res.json();
    } catch (e) {}
    return cart;
  }

  window.suprRefreshCartDiscounts = async function () {
    const res = await fetch('/cart.js', { cache: 'no-store' });
    let cart = await res.json();
    cart = await refreshCartDiscounts(cart);
    _cart = cart;
    return cart;
  };

  /** Apply whitelisted discount code (GoKwik) — automatic BXGY has no code; this is for code-based mirrors. */
  async function applyShopifyDiscountCode(code) {
    if (!code) return;
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const path = root.replace(/\/?$/, '/') + 'discount/' + encodeURIComponent(code);
    try {
      await fetch(path, { method: 'GET', credentials: 'same-origin', redirect: 'manual' });
    } catch (e) {}
  }

  window.suprApplyBrewMugDiscountCode = async function () {
    const code = getBrewMugDiscountCode();
    if (!code) return;
    const res = await fetch('/cart.js', { cache: 'no-store' });
    const cart = await res.json();
    if (!cartHasBrewMugGiftLine(cart)) return;
    await applyShopifyDiscountCode(code);
  };

  // ─── CHECKOUT URL WITH UPSELL / MUG DISCOUNT CODE ───────────────────────────
  function updateCheckoutFormAction(cart) {
    const form = document.getElementById('FcCheckoutForm');
    if (!form) return;
    const items = cart?.items || [];
    let code = '';
    if (cartHasBrewMugGiftLine(cart)) {
      code = getBrewMugDiscountCode();
    }
    if (!code) {
      code = (form.dataset.upsellDiscountCode || '').trim();
      if (code.toLowerCase() === 'none') code = '';
      const upsellIds = new Set((_upsellData || []).map((p) => p.id));
      const hasUpsellInCart = items.some((i) => !isFreebieItem(i) && upsellIds.has(i.variant_id));
      if (!hasUpsellInCart) code = '';
    }
    if (code) {
      form.action = '/checkout?discount=' + encodeURIComponent(code);
    } else {
      form.action = '/checkout';
    }
  }

  function mergeSuprCartBrewMugRuleFromDom() {
    try {
      const rule = window.__SUPR_CART_BREW_MUG_RULE__;
      if (!rule?.triggerProductId || !rule.freebies?.length) return;
      const mugId = String(rule.freebies[0].id);
      let rules = window.__SUPR_VARIANT_FREEBIE_RULES__ || [];
      rules = rules.filter(
        (r) =>
          Number(r.triggerProductId) !== Number(rule.triggerProductId) ||
          !(r.freebies || []).some((f) => String(f.id) === mugId)
      );
      rules.push(rule);
      window.__SUPR_VARIANT_FREEBIE_RULES__ = rules;
      window.sessionStorage.setItem('supr-variant-freebie-rules', JSON.stringify(rules));
      if (rule.discountCode) {
        window.sessionStorage.setItem('supr-brew-mug-discount-code', rule.discountCode);
      }
    } catch (e) {}
  }

  function hydrateVariantFreebieRulesFromStorage() {
    mergeSuprCartBrewMugRuleFromDom();
    try {
      if (window.__SUPR_VARIANT_FREEBIE_RULES__?.length) return;
      const stored = window.sessionStorage.getItem('supr-variant-freebie-rules');
      if (stored) window.__SUPR_VARIANT_FREEBIE_RULES__ = JSON.parse(stored);
    } catch (e) {}
  }

  function cartHasPaidBrewLine(items) {
    const pid = Number(document.querySelector('[data-sbp-root]')?.dataset?.productId);
    if (!pid) return (items || []).some((i) => !isFreebieItem(i));
    return (items || []).some((i) => !isFreebieItem(i) && Number(i.product_id) === pid);
  }

  function cartMatchesVariantGiftTrigger(items, giftVariantId) {
    const vid = String(giftVariantId);
    const rules = getSuprVariantFreebieRules();
    for (let r = 0; r < rules.length; r++) {
      const rule = rules[r];
      const giftIds = new Set((rule.freebies || []).map((f) => String(f.id)));
      if (!giftIds.has(vid)) continue;
      const pid = Number(rule.triggerProductId);
      const triggers = new Set((rule.triggerVariantIds || []).map(String));
      const matched = (items || []).some(
        (i) =>
          !isFreebieItem(i) &&
          Number(i.product_id) === pid &&
          triggers.has(String(i.variant_id))
      );
      if (matched) return true;
    }
    return false;
  }

  /** Keep 3 kg mug in cart while trigger variant is present (even before automatic discount → ₹0). */
  function isProtectedVariantGiftLine(item, items) {
    if (!item || !getVariantRuleOnlyFreebieIds().has(String(item.variant_id))) return false;
    if (!lineHasFreebieFlag(item) && !isFreebieItem(item)) return false;
    return cartMatchesVariantGiftTrigger(items, item.variant_id);
  }

  function missingVariantRuleFreebies(items) {
    hydrateVariantFreebieRulesFromStorage();
    const variantOnly = getVariantRuleOnlyFreebieIds();
    if (!variantOnly.size) return [];
    const meetsMin = cartValueEx(items) >= (CFG?.minCartValue || 0);
    const eligible = resolveEligibleFreebies(items, meetsMin);
    const inCart = new Set((items || []).map((i) => String(i.variant_id)));
    return eligible.filter(
      (f) => variantOnly.has(String(f.id)) && !inCart.has(String(f.id))
    );
  }

  async function ensureVariantRuleFreebiesInCart(cart) {
    const missing = missingVariantRuleFreebies(cart.items || []);
    if (!missing.length) return cart;
    await batchAddFreebies(missing, true);
    const res = await fetch('/cart.js', { cache: 'no-store' });
    return res.json();
  }

  async function waitForCartIdle(maxMs = 10000) {
    const start = Date.now();
    while ((_cartUpdating || _freebieSyncing) && Date.now() - start < maxMs) {
      await new Promise((r) => window.setTimeout(r, 80));
    }
  }

  // ─── CHECKOUT BUTTON ──────────────────────────────────────────────────────
  function updateCheckout(total, count) {
    // Support both native button and GoKwik button
    const btn = document.querySelector('#FcCheckoutForm button, .gokwik-checkout button');
    if (!btn) return;
    // Disable if cart is empty OR if cart is being updated
    const disable = (count === 0 || total === 0 || _cartUpdating);
    btn.disabled = disable;
    btn.classList.toggle('fc-disabled', disable);
  }

  // Checkout validation before GoKwik / native checkout
  document.addEventListener('click', async function(e) {
    const btn = e.target.closest('#FcCheckoutForm button, .gokwik-checkout button');
    if (!btn || btn.disabled) return;

    if (_fcCheckoutResume) {
      _fcCheckoutResume = false;
      return;
    }

    e.preventDefault();
    e.stopImmediatePropagation();

    await waitForCartIdle();
    hydrateVariantFreebieRulesFromStorage();

    try {
      _cartUpdating = true;
      updateCheckout(0, 0);
      await flushGiftNoteToCart();

      if (typeof window.suprSyncFreebies === 'function') {
        try {
          await window.suprSyncFreebies(null);
        } catch (syncErr) {
          /* best-effort */
        }
      }

      let res = await fetch('/cart.js', { cache: 'no-store' });
      let cart = await res.json();
      cart = await prepareVariantGiftsForGokwikCheckout(cart);
      cart = await refreshCartDiscounts(cart);
      if (typeof window.suprApplyBrewMugDiscountCode === 'function') {
        await window.suprApplyBrewMugDiscountCode();
      }
      res = await fetch('/cart.js', { cache: 'no-store' });
      cart = await res.json();
      _cart = cart;
      renderCart(cart);
      updateCheckoutFormAction(cart);
      const total = cartValueEx(cart.items);

      if (total === 0 || cart.items.length === 0) {
        e.preventDefault(); e.stopImmediatePropagation();
        _cartUpdating = false;
        const items = cart.items || [];
        const count = items.filter(i => !isFreebieItem(i)).length;
        updateCheckout(total, count);
        alert('Please add items to your cart before checking out.');
        return;
      }

      const freebies  = cart.items.filter(isFreebieItem);
      const eligible  = cartValueEx(cart.items) >= (CFG.minCartValue || 0)
        ? getEligibleFreebies(cart.items) : [];
      const eligIds   = new Set(eligible.map((f) => String(f.id)));
      const ourIds    = getOurFreebieVariantIds();
      let invalid, invalidQty;
      if (CFG.freebieImageOnly) {
        invalid = cart.items.filter(
          (i) => isOurManagedFreebieLine(i) && !isProtectedVariantGiftLine(i, cart.items)
        );
        invalidQty = [];
      } else {
        invalid = freebies.filter((i) => {
          if (!ourIds.has(String(i.variant_id))) return false;
          if (eligIds.has(String(i.variant_id))) return false;
          if (isProtectedVariantGiftLine(i, cart.items)) return false;
          return true;
        });
        invalidQty = freebies.filter(
          (i) => ourIds.has(String(i.variant_id)) && i.quantity > 1
        );
      }

      if (invalid.length > 0 || invalidQty.length > 0) {
        e.preventDefault(); e.stopImmediatePropagation();
        // Remove invalid freebies and fix quantities
        const upd = {};
        invalid.forEach(i => { upd[i.key] = 0; }); // Remove invalid
        invalidQty.forEach(i => { upd[i.key] = 1; }); // Set to quantity 1
        await fetch('/cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: upd })
        });
        // No delay - process immediately
        // Fetch fresh cart and validate again
        const freshRes = await fetch('/cart.js', { cache: 'no-store' });
        const freshCart = await freshRes.json();
        _cart = freshCart;
        renderCart(freshCart);
        // Re-check for invalid freebies after removal
        const freshFreebies = freshCart.items.filter(isFreebieItem);
        const freshEligible = resolveEligibleFreebies(
          freshCart.items,
          cartValueEx(freshCart.items) >= (CFG?.minCartValue || 0)
        );
        const freshEligIds = new Set(freshEligible.map((f) => String(f.id)));
        const stillInvalid = CFG.freebieImageOnly
          ? freshCart.items.filter(
              (i) => isOurManagedFreebieLine(i) && !isProtectedVariantGiftLine(i, freshCart.items)
            )
          : freshFreebies.filter((i) => {
              if (!ourIds.has(String(i.variant_id))) return false;
              if (freshEligIds.has(String(i.variant_id))) return false;
              if (isProtectedVariantGiftLine(i, freshCart.items)) return false;
              return true;
            });
        
        if (stillInvalid.length > 0) {
          // Still has invalid freebies - remove them too
          const upd2 = {}; stillInvalid.forEach(i => { upd2[i.key] = 0; });
          await fetch('/cart/update.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: upd2 })
          });
          // No delay - process immediately
        }
        
        _cartUpdating = false;
        const items = freshCart.items || [];
        const finalTotal = cartValueEx(items);
        const count = items.filter(i => !isFreebieItem(i)).length;
        updateCheckout(finalTotal, count);
        alert('Your cart was updated. Please try checkout again.');
        fetchCart();
        return;
      }
      
      _cartUpdating = false;
      const items = cart.items || [];
      const count = items.filter(i => !isFreebieItem(i)).length;
      updateCheckout(total, count);
      _fcCheckoutResume = true;
      btn.click();
      
    } catch (e) {
      _cartUpdating = false;
      const items = _cart?.items || [];
      const total = cartValueEx(items);
      const count = items.filter(i => !isFreebieItem(i)).length;
      updateCheckout(total, count);
      _fcCheckoutResume = true;
      btn.click();
    }
  }, true);

  // ─── GLOBAL LISTENERS ─────────────────────────────────────────────────────
  // Open drawer when /cart link clicked
  document.addEventListener('click', function(e) {
    const a = e.target.closest('a[href="/cart"], a[href="/cart/"]');
    if (a) { e.preventDefault(); window.openSuprCart(); }
  });

  // Re-render if global interceptor updated the cart (with optimistic freebies)
  document.addEventListener('supr:cart:updated', function() {
    fetch('/cart.js', { cache: 'no-store' })
      .then(r => r.json())
      .then(async (cart) => {
        await ensureVariantFreebieMeta(false, cart);
        cart = await enforceFreebieQuantity(cart);
        _cart = cart;
        renderCart(cart, true);
        return syncFreebiesLocal(cart, true);
      })
      .then(() => fetch('/cart.js', { cache: 'no-store' }))
      .then(r => r.json())
      .then(async (freshCart) => {
        await ensureVariantFreebieMeta(true, freshCart);
        freshCart = await syncCustomTumbler(freshCart);
        _cart = freshCart;
        renderCart(freshCart, false);
      });
  });

  // Disable checkout when global freebie operations start
  let _freebieSyncing = false;
  document.addEventListener('supr:freebie:syncing', function(e) {
    if (e.detail && e.detail.starting) {
      _freebieSyncing = true;
      _cartUpdating = true;
      updateCheckout(0, 0); // Disable checkout immediately
    } else {
      // Freebie operations complete - wait for cart update, then re-enable checkout
      _freebieSyncing = false;
      // Wait a bit for cart:updated event to trigger fetchCart()
      // If fetchCart doesn't run, re-enable checkout as fallback
      setTimeout(() => {
        if (!_cartUpdating && _cart) {
          const items = _cart.items || [];
          const total = cartValueEx(items);
          const count = items.filter(i => !isFreebieItem(i)).length;
          updateCheckout(total, count);
        }
      }, 500);
    }
  });

  // ─── INIT ─────────────────────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', function() {
    updateEstimatedDeliveryDate();
    initUpsells();
    initGiftNoteField();
    initCustomTumblerField();
    // Pre-check initial cart for checkout button state
    fetch('/cart.js').then(r => r.json()).then(cart => {
      _cart = cart;
      updateCheckout(cartValueEx(cart.items), cart.items.filter(i => !isFreebieItem(i)).length);
    });
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
